import { styled } from 'styled-components'

export const Image = styled.img`
    height: 280px;
    width: 327px;
    width: 80%;
    object-fit: fill;
    padding: 0 0 12px 0;
   @media (min-width: 744px) {
        height: 340px;
        width: 564px;
     }


`